var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Panel',{staticClass:"tournament-info-wrapper_game-selector",attrs:{"variant":['30-paddings', 'default', 'rounded']}},[_c('TournamentGameSetting'),_c('TournamentPlatformSetting')],1)}
var staticRenderFns = []

export { render, staticRenderFns }